module.exports = __webpack_public_path__ + "static/media/blackFrame.e0eca8a7.png";